import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export interface DaypartGlobalComponentItem {
  id: number;
  component_id: number;
  daypart_id: number;
  created_at?: string;
  modified_at?: string;
  position?: number;
}

export const useGetDaypartGlobalComponents = (
  overrideQuerySetting?: UseQueryOptions<DaypartGlobalComponentItem[]>,
) => {
  return useQuery({
    queryKey: queryKeys.daypartGlobalComponent.all(),
    queryFn: fetchDaypartGlobalComponents,
    staleTime: Infinity,
    ...overrideQuerySetting,
  });
};

export const fetchDaypartGlobalComponents = async (): Promise<
  DaypartGlobalComponentItem[]
> => {
  const response = await requestCCApi({
    url: '/daypartGlobalComponents?pageSize=0',
  });

  if (response.data) {
    return response.data;
  }

  return [];
};
